import React from "react";

export const LazyLexiconPage = React.lazy(
    () => import(/* webpackChunkName: "LexiconPage" */ "./LexiconPage")
);
